module.exports = __webpack_public_path__ + "static/img/hezuo2.32c4f56.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezuo2.png
// module id = Xqex
// module chunks = 1